import React from 'react';

import PropTypes from 'prop-types';

import { timestampToDate } from '~/helpers';

import { Card } from '..';

export default function Graph({
  alarms,
  graphics,
  maintenance,
  filter,
  onCallback,
  setCanUpdateArqueacao,
  canOpenArqueacaoAutomaticaModal,
  openArqueacaoAutomaticaModal,
  ...rest
}) {
  function handleSerializeObject(obj) {
    const {
      nomeposto,
      codigotanquefisico,
      nomearqueacao,
      nomeproduto,
      capacidadeoperacionaltanquefisico,
      volumeespacovaziotanquefisico,
      volume1tanquefisico,
      alarmenivelbaixotanquefisico,
      dataleituratanquefisico,
      idtanquefisico,
      idcliente,
      idposto,
      volcontabiltanquefisico,
      capacidadetanquefisico,
      corproduto,
      alturanivel1tanquefisico,
      temperaturamediatanquefisico,
      alturanivel2tanquefisico,
      volume2tanquefisico,
      tiposondatanquefisico,
      idhistoricoarqaut,
    } = obj;

    const datasets = [
      {
        label: 'Estoque',
        backgroundColor: obj.corproduto,
        data: [volume1tanquefisico],
      },
      {
        label: 'Espaço Vazio',
        backgroundColor: 'silver',
        data: [volumeespacovaziotanquefisico],
      },
    ];

    return {
      nome_posto: nomeposto,
      tafi_codigo: codigotanquefisico, // Tanque
      poco_desc_abrev: nomearqueacao, // Posto
      prod_display: nomeproduto.toUpperCase(), // Produto
      tafi_capacidade: capacidadetanquefisico, // Capacidade
      // tafi_capacidade: capacidadeoperacionaltanquefisico, // Capacidade
      capacidadeoperacionaltanquefisico, // capacidadeoperacionaltanquefisico
      tafi_live: volumeespacovaziotanquefisico, // Espaço Livre
      tafi_volume_cont: volume1tanquefisico, // Estoque Físico
      ressuprimento:
        (alarmenivelbaixotanquefisico * capacidadeoperacionaltanquefisico) /
        100, // Ressuprimento
      comunicacao: dataleituratanquefisico
        ? timestampToDate(dataleituratanquefisico, true)
        : '', // Última Comunicação
      alarmes: obj.countalarmestanque > 0,
      status_comunicacao: obj.falhacomunicacaotanquefisico > 0,
      alerta_ressuprimento: obj.alertaressuprimentotanquefisico > 0,
      em_manutencao: obj.manutencaotanquefisico !== 'N',
      em_descarga: !obj.finalizadadescarganf,
      volcontabiltanquefisico,
      alturanivel1tanquefisico,
      temperaturamediatanquefisico,
      fisico: {
        value: volume1tanquefisico,
        max: capacidadetanquefisico,
        color: corproduto,
      },
      data: {
        datasets,
      },
      graphic: { idcliente, idposto, idtanquefisico },
      alturanivel2tanquefisico,
      volume2tanquefisico,
      tiposondatanquefisico,
      tipodescargaposto: obj.tipodescargaposto,
      idhistoricoarqaut,
      idcliente,
      idposto,
      idtanquefisico,
    };
  }

  return (
    <Card
      alarms={(params) => alarms(params)}
      graphics={(params) => graphics(params)}
      maintenance={(params) => maintenance(params)}
      filter={filter}
      tank={handleSerializeObject(rest)}
      onCallback={(params) => onCallback(params)}
      canOpenArqueacaoAutomaticaModal={canOpenArqueacaoAutomaticaModal}
      openArqueacaoAutomaticaModal={openArqueacaoAutomaticaModal}
    />
  );
}

Graph.propTypes = {
  alarms: PropTypes.func.isRequired,
  graphics: PropTypes.func.isRequired,
  maintenance: PropTypes.func.isRequired,
  onCallback: PropTypes.func,
  canOpenArqueacaoAutomaticaModal: PropTypes.bool.isRequired,
  openArqueacaoAutomaticaModal: PropTypes.func.isRequired,
};
